import lazyWithRetry from '@shared/lib/lazyWithRetry';
import Loadable from '@components/Loadable/Loadable';

const CaseCreatePage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/create.tsx'))
);
const CaseEditPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/edit.tsx'))
);
const CaseViewPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/view.tsx'))
);
const CaseChatPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/chat.tsx'))
);

const CaseDemandV2Page = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/demand-v2.tsx'))
);

const CaseInfoSheetPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/info-sheet.tsx'))
);

const CaseChildRoutes = {
  path: 'cases',
  children: [
    {
      path: 'create',
      element: <CaseCreatePage />,
    },
    {
      path: 'edit/:case_id',
      element: <CaseEditPage />,
    },
    {
      path: 'view/:case_id',
      element: <CaseViewPage />,
    },
    {
      path: 'chat/:case_id',
      element: <CaseChatPage />,
    },
    {
      // ZLAYT-1656: staff only, behind VITE_DEMAND_LETTER_V2_TEST.
      path: 'demand-v2/:case_id',
      element: <CaseDemandV2Page />,
    },
    {
      path: 'info-sheet/:case_id',
      element: <CaseInfoSheetPage />,
    },
  ],
};

export default CaseChildRoutes;
